// extracted by mini-css-extract-plugin
export default {"fullWidth":"zo-z","image":"Ao-z","lazyLoadPicture":"Bo-z","lazyLoadSpinner":"Co-z","lazyLoadSpin":"Do-z","lazyLoadImage":"Eo-z","hasStyledAspectRatio":"Fo-z"};